import React from "react";
import { useColorScheme } from "@/hooks/useColorScheme";
import { Stack } from "expo-router";

// See: https://medium.com/@siddhantshelake/best-practices-for-expo-router-tabs-stacks-shared-screens-b3cacc3e8ebb
// For suggestions on "z_shared"

export default function SharedLayout() {
  return (
    <Stack screenOptions={{ headerShown: false }}>
      <Stack.Screen name="quota" options={{ title: "Storage Quota" }} />
      <Stack.Screen name="terminate-account" options={{ title: "Terminate Account" }} />
    </Stack>
  );
}
